<template>
  <div
    role="status"
    class="bg-black bg-opacity-35 absolute inset-0 m-auto flex items-center justify-center"
  >
    <span class="loading loading-spinner loading-sm" aria-hidden="true" />
    <span class="sr-only">{{ label }}</span>

    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
  }>(),
  {
    label: "Loading",
  },
);
</script>
